/* eslint-disable import/no-unresolved */
const baseInstoreInventory = require('storepickup-base/product/pdpInstoreInventory');
const lozad = require('lozad');
const storeLocator = require('../storeLocator/storeLocator');
const pickupModal = require('../components/pickupModal');
const formLabelHelpers = require('../components/form');


/**
 * Trigger lozad
 */
function triggerLozad() {
    const observer = lozad();
    observer.observe();
}


function appendToUrl(url, params) {
    let newUrl = url;
    newUrl
        += (newUrl.indexOf('?') !== -1 ? '&' : '?')
        + Object.keys(params)
            .map(key => `${key}=${encodeURIComponent(params[key])}`)
            .join('&');

    return newUrl;
}

/**
 * Generates the modal window on the first call.
 */
function getModalHtmlElement() {
    if ($('#inStoreInventoryModal').length !== 0) {
        $('#inStoreInventoryModal').remove();
    }
    const htmlString = `${'<!-- Modal -->'
            + '<div class="modal " id="inStoreInventoryModal" role="dialog">'
            + '<div class="modal-dialog big in-store-inventory-dialog">'
            + '<!-- Modal content-->'
            + '<div class="modal-content">'
            + '<div class="modal-header justify-content-end">'
            + '    <button type="button" class="close pull-right no-btn icon-cross-line" data-dismiss="modal" title="'}${$(
        '.btn-get-in-store-inventory',
    ).data('modal-close-text')}">`
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';

    $('body').append(htmlString);
    $('#inStoreInventoryModal').modal('show');
}

/**
 * Replaces the content in the modal window with find stores components and
 * the result store list.
 * @param {string} pid - The product ID to search for
 * @param {number} quantity - Number of products to search inventory for
 * @param {number} selectedPostalCode - The postal code to search for inventory
 * @param {number} selectedRadius - The radius to search for inventory
 */
function fillModalElement(pid, quantity, selectedPostalCode, selectedRadius) {
    const requestData = {
        products: `${pid}:${quantity}`,
    };

    if (selectedRadius) {
        requestData.radius = selectedRadius;
    }

    if (selectedPostalCode) {
        requestData.postalCode = selectedPostalCode;
    }

    $('#inStoreInventoryModal')
        .spinner()
        .start();

    $.ajax({
        url: $('.btn-get-in-store-inventory').data('action-url'),
        data: requestData,
        method: 'GET',
        success(response) {
            $('#inStoreInventoryModal').find('.modal-body').empty();
            $('#inStoreInventoryModal').find('.modal-body').html(response.storesResultsHtml);
            storeLocator.search();
            storeLocator.changeRadius();
            storeLocator.selectStore();
            storeLocator.updateSelectStoreButton();

            $('.btn-storelocator-search').attr('data-search-pid', pid);

            if (selectedRadius) {
                $('#radius').val(selectedRadius);
            }

            if (selectedPostalCode) {
                $('#store-postal-code').val(selectedPostalCode);
            }

            if (!$('.results').data('has-results')) {
                $('.store-locator-no-results').show();
            }

            // Instorepickup map inicialization when the modal are ready for be used
            pickupModal.mapInicializationOnModal();

            $('#inStoreInventoryModal').modal('show');
            $('#inStoreInventoryModal')
                .spinner()
                .stop();
            triggerLozad();
            formLabelHelpers.inputFocus();
        },
        error() {
            $('#inStoreInventoryModal')
                .spinner()
                .stop();
        },
    });
}

/**
 * Replaces the content in the modal window with find stores components and
 * the result store list.
 * @param {string} pid - The product ID to search for
 * @param {number} quantity - Number of products to search inventory for
 * @param {number} selectedPostalCode - The postal code to search for inventory
 * @param {number} selectedRadius - The radius to search for inventory
 */
function fillModalElementPDP(pid, quantity) {
    const data = { pid, quantity };
    $('#inStoreInventoryModal')
        .find('.modal-body')
        .spinner()
        .start();

    const url = $('.availabilityinstore').data('url');
    const html = $('html');
    const docBody = $(document.body);

    $.ajax({
        url,
        method: 'GET',
        dataType: 'json',
        data,
        success(response) {
            const inStoreModal = $('#inStoreInventoryModal');

            inStoreModal
                .find('.modal-body')
                .empty()
                .html(response.renderedTemplate);

            html.addClass('modal-active');
            inStoreModal.modal('show');
            $.spinner().stop();

            const storeAvailability = $('#storeAvailability');
            const modalText = $('.results-wrapper .nameproduct, .results-wrapper .info');
            const resultsWrapper = $('.results-wrapper');

            $('#state').on('change', (e) => {
                e.preventDefault();
                $('.result').empty();
                storeAvailability.slideDown();
                modalText.slideDown();
                resultsWrapper.removeClass('active');
            });

            storeAvailability.on('click', (e) => {
                e.preventDefault();

                const requestData = {
                    pid,
                    quantity,
                    state: $('#state').val(),
                };
                const newUrl = appendToUrl(storeAvailability.data('url'), requestData);

                storeAvailability.slideUp('fast');
                modalText.slideUp('fast');
                resultsWrapper.delay(100).addClass('active');

                $.ajax({
                    url: newUrl,
                    method: 'POST',
                    success(responseStock) {
                        const result = $('.result');
                        result.hide().empty().append(responseStock.renderedTemplate).slideDown();

                        $('.consulta-stock').on('click', (event) => {
                            event.preventDefault();
                            const thisTarget = $(event.currentTarget);
                            const targetParent = thisTarget.parent();
                            const msg = thisTarget.data('msg');
                            let msgClass = '';

                            if (msg.indexOf('No') !== -1) {
                                msgClass = 'out-of-stock';
                            }

                            thisTarget.fadeOut('fast');
                            targetParent.append(`<p>${msg}</p>`);
                            targetParent.find('p').addClass(msgClass).delay(100).fadeIn();
                        });
                    },
                    error() {},
                });
            });
        },
        error() {
            $.spinner().stop();
        },
    });

    docBody.on('click', '#inStoreInventoryModal .icon-close', () => {
        $('#inStoreInventoryModal').modal('hide');
        html.removeClass('modal-active');
    });

    docBody.on('click', '.modal-backdrop', () => {
        html.removeClass('modal-active');
    });
}

baseInstoreInventory.changeStore = () => {
    $('body').on('click', '.change-store', (e) => {
        const pid = $(e.currentTarget)
            .closest('.product-detail')
            .attr('data-pid');
        const quantity = $(e.currentTarget)
            .closest('.product-detail')
            .find('.quantity')
            .val();
        getModalHtmlElement();

        fillModalElement(
            pid,
            quantity,
            $(e.currentTarget).data('postal'),
            $(e.currentTarget).data('radius'),
        );
    });
};

baseInstoreInventory.showInStoreInventory = () => {
    $('.btn-get-in-store-inventory').on('click', (e) => {
        const pid = $(e.currentTarget)
            .closest('.product-detail')
            .attr('data-pid');
        const quantity = $(e.currentTarget)
            .closest('.product-detail')
            .find('.quantity')
            .val();
        getModalHtmlElement();
        fillModalElement(pid, quantity);
        e.stopPropagation();
    });
};

module.exports = {
    ...baseInstoreInventory,
    createPopupPdpStore(pid, quantity) {
        if (pid && quantity) {
            getModalHtmlElement();
            fillModalElementPDP(pid, quantity);
        }
    },

    searchInventoryStores() {
        const docBody = $(document.body);
        docBody.on('click', '.btn-store-inventory-search', () => {
            $('#store-inventory-modal').modal('show');
            $('#store-inventory-close').on('click', () => {
                $('#store-inventory-modal').modal('hide');
            });
        });
    },

};
